import React, {useEffect,useRef, useState, useCallback} from 'react';
import {gsap, SteppedEase, /*TimelineMax,*/ TweenMax} from "gsap";
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollMagic from "scrollmagic";
import {useSelector} from "react-redux";
gsap.registerPlugin(ScrollTrigger);


const SpinningProduct = (props) => {

    const windowData = useSelector(state => state.window);
    const spin = useRef();
    const trigger = useRef();
    const animation = useRef();


    const calculateStyle = useCallback(()=>{

        animation.current = {...props.animation};
        animation.current.size = '100%';
        animation.current.height = animation.current.h / animation.current.f;

        if((windowData.width > 768 && windowData.width < 1000) || windowData.width < 768){
            let newWidthRatio = 350 / props.animation.w ;

            animation.current = {
                w: 350,
                h: props.animation.h * newWidthRatio,
                f: props.animation.f,
            }

        }

        return {
            position: 'relative',
            backgroundImage: `url(${props.src})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100%',
            backgroundPosition: 'center top',
            width: animation.current.w,
            height: animation.current.h / animation.current.f
        }

    },[props, windowData])

    const [styleData, setStyleData] = useState(calculateStyle());

    useEffect(()=>{

        setTimeout(()=>{

            let frameHeight = animation.current.h / animation.current.f
            let height = animation.current.h - frameHeight; // stop 1 frame before the total end
            let frames = animation.current.f-1; // stop 1 frame before the total end

            if(spin.current){

                let animation = TweenMax.to(spin.current, {
                    scrollTrigger: '.productTrigger',
                    backgroundPosition: `0 -${height}px`, ease:SteppedEase.config(frames),
                    onComplete: ()=>{
                        // if(spin.current) spin.current.style.backgroundPosition= 'center bottom';
                    }
                }).pause();

                let controller = new ScrollMagic.Controller({ container: props.scroller });

                let scene = new ScrollMagic.Scene({
                    offset: 50,
                    triggerElement: spin.current})
                    .addTo(controller);

                scene.on("enter", function (e) {
                    if(e.scrollDirection === 'FORWARD'){
                        animation.duration(1.5).play();
                    }
                });

                scene.on("leave", function (e) {
                    if(e.scrollDirection === 'REVERSE'){
                        animation.duration(1.5).reverse();
                    }
                });

            }

        }, 0);

    }, [props, styleData])

    useEffect(()=>{
        setStyleData(calculateStyle())
    }, [windowData, setStyleData, calculateStyle])

    let triggerStyle = {
        position:'absolute',
        top: windowData.width > 768 ? -50 : -300
    }

    return (
        <>
            <div key={windowData.width} aria-label={`Rotating ${props.title} image`} ref={spin} style={styleData}>
                <div ref={trigger} className={'productTrigger'} style={triggerStyle}/>
            </div>
        </>
    )
};

export default SpinningProduct
